import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberKM'
})
export class NumberKMPipe implements PipeTransform {

  static formatDynamic(number: number, uom = '') {
    if (Math.abs(number) < 1000) {
      return number.toFixed(2) + uom;
    }

    number = number / 1000;
    if (Math.abs(number) < 1000) {
      return number.toFixed(2) + ' K' + uom;
    }

    number = number / 1000;
    return number.toFixed(2) + ' M' + uom;
  }

  transform(number: number, args?: any): string {
    if (typeof number === 'undefined') {
      return '';
    }

    return NumberKMPipe.formatDynamic(number);
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/numberKMPipe.ts